import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import Slider from "./components/Slider";
import SliderSettings from "./components/SliderSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/slider_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'slider',
    group: ElementGroup.SELECT,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_SLIDER'],
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        range: false,
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_SLIDER']
      },
      settings: {
        width: {
          value: "100%"
        },
      }
    },
    pluginComponent: Slider, // 插件渲染组件
    pluginSettingComponent: SliderSettings, // 插件设置项组件
  }
}
